function VideoEntryController(clickCallback) {
	console.log('BAM');

	$('.viewTranscript').on('click',function(e){
		console.log('BAM',$('.transcript'));
		$('.transcript').slideToggle();
	});

}

module.exports = VideoEntryController;



// WEBPACK FOOTER //
// ./js/src/VideoEntryController.js